// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"18bb91bf","893":"826d9a76"}[chunkId] + ".chunk.js";
};